export class Cookie {
  constructor(
    private key: string,
    private value: string,
    private expires?: Date | number,
    private path?: string,
    private domain?: string
  ) {}

  public getString(): string {
    let cookieString: string =
      encodeURIComponent(this.key) + '=' + encodeURIComponent(this.value) + ';';

    if (this.expires) {
      cookieString += 'expires=' + this.getExpiresString() + ';';
    }

    if (this.path) {
      cookieString += 'path=' + this.path + ';';
    }

    if (this.domain) {
      cookieString += 'domain=' + this.domain + ';';
    }

    return cookieString;
  }

  private getExpiresString(): string {
    if (typeof this.expires === 'number') {
      const dateExpires: Date = new Date(new Date().getTime() + this.expires * 1000 * 60 * 60 * 24);

      return dateExpires.toUTCString();
    }

    return this.expires.toUTCString();
  }
}
